export default {
    version: 8,
    name: 'plat_blank',
    metadata: {
        'mapbox:autocomposite': true,
        'mapbox:type': 'template',
        'mapbox:sdk-support': {
            android: '10.0.0',
            ios: '10.0.0',
            js: '2.6.0',
        },
        'mapbox:groups': {},
        'mapbox:uiParadigm': 'components',
    },
    center: [0, 0],
    zoom: 0.81698360279739,
    bearing: 0,
    pitch: 0,
    sources: {},
    sprite: 'mapbox://sprites/metocean/cl1ph314e000214mfqutue1hr/ck2u8j60r58fu0sgyxrigm3cu',
    glyphs: 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf',
    layers: [],
    created: '2022-04-07T20:49:37.669Z',
    modified: '2022-04-07T20:49:55.395Z',
    id: 'cl1ph314e000214mfqutue1hr',
    owner: 'metocean',
    visibility: 'private',
    protected: false,
    draft: false,
};
